module.exports = __webpack_public_path__ + "img/ac12.ca9c3df5.png";